import { useFormik } from 'formik'
import { useTranslation } from 'react-i18next'
import validationSchema from '../../utils/validationSchema'
import RenderIf from '../UI/RenderIf'
import { CreatePasswordFormTypes } from '../../interfaces/passwrod-form'
import InputErrorMessage from '../UI/InputErrorMsg'
import Spinner from '../UI/Spinner'

const inputDivClasses = 'relative flex flex-col mt-8 text-grey-pale w-full'

interface Props {
  onSubmit: (values:CreatePasswordFormTypes) => void,
  btnText: string,
  isLoading: boolean
}

function PasswordForm({ onSubmit, btnText, isLoading }: Props) {
  const { t } = useTranslation()

  const formik = useFormik({
    initialValues: {
      password: '',
      confirmPassword: ''
    },
    validationSchema: validationSchema.activatePassword,
    onSubmit
  })

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className={`${inputDivClasses} mb-3`}>
        <label htmlFor="email" className="mb-2">
          {t('password')}
        </label>
        <input
          className={`border py-1 px-2 rounded-[5px] h-12 outline-none w-full ${formik.errors.password && formik.touched.password ? 'border-red-700' : 'border-[#BEBEBE]'
            // eslint-disable-next-line @typescript-eslint/indent
          }`}
          id="email"
          type="password"
          {...formik.getFieldProps('password')}
        />
        <RenderIf isTrue={!!(formik.errors.password && formik.touched.password)}>
          <div className="ml-0.5 mt-1">
            <InputErrorMessage text={formik.errors.password!} />
          </div>
        </RenderIf>
      </div>
      <div className={`${inputDivClasses} mb-3`}>
        <label htmlFor="email" className="mb-2">
          {t('confirmPassword')}
        </label>
        <input
          className={`border-2 py-1 px-2 rounded-[5px] h-12 outline-none w-full ${formik.errors.confirmPassword && formik.touched.confirmPassword ? 'border-red-700' : 'border-gray-400'
            // eslint-disable-next-line @typescript-eslint/indent
          }`}
          id="email"
          type="password"
          {...formik.getFieldProps('confirmPassword')}
        />
        <RenderIf isTrue={!!(formik.errors.confirmPassword && formik.touched.confirmPassword)}>
          <div className="ml-0.5 mt-1">
            <InputErrorMessage text={formik.errors.confirmPassword!} />
          </div>
        </RenderIf>
      </div>
      <div className={inputDivClasses}>
        <button
          className="text-white text-[18px] bg-btn-sub w-full text-center mx-auto px-2 py-4 rounded-[5px] w-full"
          type="submit"
        >
          {isLoading ? <Spinner /> : t(btnText)}
        </button>
      </div>
    </form>
  )
}
export default PasswordForm
